import { z } from "zod";
import { REQUIRED_FIELD } from "../../../utils/constants";

export const LoginItemSchema = z.object({
  email: z.string().min(1, { message: REQUIRED_FIELD }).email("Email inválido"),
  password: z.string().min(1, { message: REQUIRED_FIELD }),
});

export const PassowrdItemSchema = z
  .object({
    newPassword: z
      .string()
      .min(1, { message: REQUIRED_FIELD })
      .min(12, "A senha deve ter pelo menos 12 caracteres")
      .regex(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula")
      .regex(/[a-z]/, "A senha deve conter pelo menos uma letra minúscula")
      .regex(/[0-9]/, "A senha deve conter pelo menos um número")
      .regex(
        /[^A-Za-z0-9]/,
        "A senha deve conter pelo menos um caractere especial",
      ),
    confirmPassword: z.string().min(1, { message: REQUIRED_FIELD }),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "As senhas não coincidem",
  });
